import PrivateLayout from './PrivateLayout'

export default PrivateLayout
